export default "__VITE_ASSET__DTU3Pw5Y__"